import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const getFormattedSyncedTime = (isoDate: string) => {
  const date = new Date(isoDate);

  if (!isValid(date)) {
    return null;
  }

  return {
    time: formatInTimeZone(date, 'Europe/Zurich', 'HH:mm:ss'),
    date: formatInTimeZone(date, 'Europe/Zurich', 'dd.MM.yyyy'),
  };
};

export default getFormattedSyncedTime;
